(() => {
  const initBoulderujMegaMenu = () => {
    document.querySelectorAll(".list-menu--inline").forEach((menu) => {
      if (menu.dataset.boulderujMegaMenuReady === "true") return;

      const megaMenuItems = Array.from(
        menu.querySelectorAll(".list-menu--megamenu")
      );

      if (!megaMenuItems.length) return;

      menu.dataset.boulderujMegaMenuReady = "true";

      let activeItem = null;
      let switchingTimer = null;

      megaMenuItems.forEach((item) => {
        item.addEventListener("mouseenter", () => {
          const isSwitching = activeItem && activeItem !== item;

          megaMenuItems.forEach((menuItem) => {
            menuItem.classList.remove("boulderuj-mega-entering");
          });

          if (isSwitching) {
            window.clearTimeout(switchingTimer);

            menu.classList.add("boulderuj-mega-switching");
            item.classList.add("boulderuj-mega-entering");

            switchingTimer = window.setTimeout(() => {
              menu.classList.remove("boulderuj-mega-switching");
              item.classList.remove("boulderuj-mega-entering");
            }, 240);
          }

          activeItem = item;
        });
      });

      menu.addEventListener("mouseleave", () => {
        window.clearTimeout(switchingTimer);

        activeItem = null;
        menu.classList.remove("boulderuj-mega-switching");

        megaMenuItems.forEach((item) => {
          item.classList.remove("boulderuj-mega-entering");
        });
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBoulderujMegaMenu);
  } else {
    initBoulderujMegaMenu();
  }

  document.addEventListener("shopify:section:load", initBoulderujMegaMenu);
})();